export type Base64 = {
  isBase64Encoded(input: any): boolean;
  encodeBase64(input: string, padding?: boolean): string;
  decodeBase64(input: string): string;
  decodeBase64Url(input: string): string;
  encodeBase64Url(input: string): string;
};

export default (): Base64 => {
  return {
    isBase64Encoded(input) {
      return isBase64Encoded(input);
    },

    encodeBase64(input: string, padding = true): string {
      return encode(input, padding);
    },

    decodeBase64(input: string): string {
      return decode(input);
    },

    decodeBase64Url(input: string): string {
      return decodeBase64Url(input);
    },

    encodeBase64Url(input: string): string {
      return encodeBase64Url(input);
    },
  };
};

/**
 * Regex to determine if a string is Base64-encoded
 */
const base64regex =
  /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

/**
 * Is input Base64-encoded
 * @param {String} input
 * @returns {boolean} true if input is Base64-encoded, false otherwise
 */
export function isBase64Encoded(input) {
  return base64regex.test(input);
}

/**
 * Base64-encode a string
 * @param {string} input String to base64-encode
 * @param {boolean} padding add padding
 * @returns {string} Base64-encoded input string
 */
export function encode(input: string, padding = true): string {
  if (padding) {
    return Buffer.from(input).toString('base64');
  }
  return Buffer.from(input).toString('base64').replace(/=/g, '');
}

/**
 * Base64-decode a string
 * @param {string} input
 * @returns {string} Base64-decoded input string
 */
export function decode(input: string): string {
  // eslint-disable-next-line no-param-reassign
  if (input.length % 4 !== 0) input += '='.repeat(4 - (input.length % 4));
  return Buffer.from(input, 'base64').toString();
}

let enc;
if (Buffer.isEncoding('base64url')) {
  enc = (input, encoding: BufferEncoding = 'utf8') =>
    Buffer.from(input, encoding).toString('base64url');
} else {
  const fromBase64 = (base64) =>
    base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
  enc = (input, encoding: BufferEncoding = 'utf8') =>
    fromBase64(Buffer.from(input, encoding).toString('base64'));
}

/**
 * Decode Base64URL
 * @param {*} input the string to decode
 * @returns {String} the decoded string.
 */
export const decodeBase64Url = (input) => `${Buffer.from(input, 'base64')}`;

/**
 * Encode Base65URL
 * @param {*} input the string to encode
 * @returns {String} the encoded string.
 */
export const encodeBase64Url = enc;
